module.exports = __webpack_public_path__ + "static/media/SofiaProItalic.d621fdcd.otf";